<div class="social_main_container">
    <div class="social_header_content">
        <div style="margin-bottom: 20px;display: flex;justify-content: space-between;align-items: center;">
            <div class="content_header">Social Media Account</div>
            <div class=" content_button">
                <button class="add_account" (click)="ContentDialogBox()"><mat-icon
                        style="margin-right: 5px;">add</mat-icon><span style="letter-spacing: 1px;word-spacing: 1px;padding-right: 5px;">Account</span></button>
            </div>
        </div>
        <div class="underline"></div>
        <div>
            <div style="margin: 20px 0px; font-family: var(--font);font-size: 16px;letter-spacing: 1px;word-spacing: 1px;">Connect and
                manage your social media channels from here.</div>
            <div class="social_channel_details">
                <div *ngIf="!dataSource.filterPredicate.length" class="no-data" style="text-align: center;">
                    <img src="assets/svg/profile.svg" alt="No accounts to display" class="payment_image">
                    <p style="font-family: var(--font); font-size: 50px;color: grey; text-align: center;padding: 10px 0px;line-height: 1;">No accounts to display</p>
                </div>
                <div *ngIf="dataSource.filterPredicate.length" class="social_accounts_details">
                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                        <ng-container matColumnDef="UserName">
                            <th mat-header-cell *matHeaderCellDef>User Name</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="client_profile_container">
                                    <span>
                                        <img [src]="getImagePath(element.AccountType)" [alt]="element.AccountType"
                                            class="social_icon">
                                    </span>
                                    <span style="font-family: var(--font);font-size: 17px;letter-spacing: 1px;word-spacing: 1px;">{{element.AccountName}} </span>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="AccountId">
                            <th mat-header-cell *matHeaderCellDef>Account Id</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="client_profile_container">
                                    <span style="font-family: var(--font);font-size: 17px;letter-spacing: 1px;word-spacing: 1px;">{{element.SocialMediaId}} </span>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="Created_On">
                            <th mat-header-cell *matHeaderCellDef> Added On </th>
                            <td mat-cell *matCellDef="let element" style="font-family: var(--font);font-size: 17px;letter-spacing: 1px;
word-spacing: 1px;"> {{element.CreatedOn}} </td>
                        </ng-container>
                        <ng-container matColumnDef="Ended_on">
                            <th mat-header-cell *matHeaderCellDef>End Date </th>
                            <td mat-cell *matCellDef="let element" style="font-family: var(--font);font-size: 17px;letter-spacing: 1px;
word-spacing: 1px;"> {{element.EndDate}} </td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef> Status </th>
                            <td mat-cell *matCellDef="let element">
                                <span style="display: flex; align-items: center;font-family: var(--font);font-size: 17px;letter-spacing: 1px;word-spacing: 1px;">
                                    {{element.Status}}
                                </span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="delete">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let element">
                                <span style="display: flex; align-items: center;font-family: var(--font);font-size: 17px;letter-spacing: 1px;word-spacing: 1px;">
                                   <button (click)="DeleteAccount(element.AccountId,element.AccountName)" style="border: none;background-color: white;"><mat-icon>delete</mat-icon></button>
                                </span>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
                <div style="text-align: center;">
                    <img src="assets\no_payments.jpg" alt="" class="payment_image">
                </div>
            </div>
        </div>
    </div>
</div>